module.exports = __webpack_public_path__ + "static/media/prototype.39ac4f69.svg";